/* Quick Shop only. Does not replace theme/slate constructors or shared cart handlers. */
(function () {
  'use strict';
  if (window.titscoQuickShopSize) {
    window.titscoQuickShopSize.scan();
    return;
  }
  var pending = false;
  var states = new WeakMap();

  function getVariant(product, values) {
    if (values.some(function (value) { return !value; })) return null;
    return product.variants.find(function (variant) {
      return values.every(function (value, index) { return variant.options[index] === value; });
    }) || null;
  }

  function render(state) {
    var values = state.options.map(function (select) { return select.value; });
    var needsSize = state.options.some(function (select) { return select.hasAttribute('data-size-option') && !select.value; });
    var variant = getVariant(state.product, values);
    // Clear the submitted ID before changing any purchase state, including invalid combinations.
    state.master.value = '';
    state.master.disabled = true;
    state.add.disabled = true;
    state.variant = variant;
    if (state.busy) {
      state.add.textContent = 'Adding...';
      return;
    }
    state.add.textContent = needsSize ? 'Choose your size' : !variant ? 'Unavailable' : !variant.available ? 'Sold out' : 'Add to cart';
    state.status.textContent = needsSize ? 'Choose your size' : !variant || !variant.available ? 'This combination is unavailable. Choose another colour or size.' : 'Selected: ' + variant.title;
    if (!needsSize && variant && variant.available) {
      state.master.value = String(variant.id);
      state.master.disabled = false;
      state.add.disabled = false;
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        state.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
        if (state.compare) {
          state.compare.hidden = !(variant.compare_at_price > variant.price);
          state.compare.innerHTML = state.compare.hidden ? '' : theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat);
        }
      }
    }
  }

  function init(root) {
    if (states.has(root)) return;
    var state = {
      root: root,
      form: root.querySelector('form'),
      product: JSON.parse(root.querySelector('[data-quickshop-product]').textContent),
      options: Array.prototype.slice.call(root.querySelectorAll('[data-quickshop-option]')),
      master: root.querySelector('[data-quickshop-variant]'),
      add: root.querySelector('[data-quickshop-add]'),
      status: root.querySelector('[data-quickshop-status]'),
      price: root.querySelector('[data-quickshop-price]'),
      compare: root.querySelector('[data-quickshop-compare]'),
      busy: false
    };
    states.set(root, state);
    render(state);
    var wrapper = root.closest('.shopWrapper');
    function returnToTrigger() {
      var card = wrapper && wrapper.closest('.grid-view-item');
      var trigger = card && card.querySelector('.quickShop');
      if (trigger) trigger.focus();
    }
    if (wrapper) {
      wrapper.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          wrapper.classList.remove('active');
          returnToTrigger();
        }
      });
      var close = wrapper.querySelector('.closeShop');
      if (close) close.addEventListener('click', returnToTrigger);
    }
    state.form.addEventListener('change', function () { render(state); });
    state.form.addEventListener('submit', function (event) {
      render(state);
      if (pending || state.busy || state.add.disabled || !state.variant || !state.variant.available) {
        event.preventDefault();
        if (!pending && !state.busy) {
          state.status.textContent = 'Choose your size and an available combination before adding to cart.';
          var missing = state.options.find(function (select) { return !select.value; });
          if (missing) missing.focus();
        }
        return;
      }
      // Native submission remains valid when the theme's Ajax cart is disabled.
      if (!window.theme || !theme.ajax_cart || !window.CartJS) return;
      event.preventDefault();
      var id = state.master.value;
      var quantity = Number(state.form.elements.quantity.value);
      if (!Number.isInteger(quantity) || quantity < 1) {
        state.status.textContent = 'Choose a valid quantity.';
        return;
      }
      pending = state.busy = true;
      state.options.forEach(function (select) { select.disabled = true; });
      state.form.setAttribute('aria-busy', 'true');
      state.status.textContent = 'Adding your selected garment...';
      render(state);
      function finish() {
        pending = state.busy = false;
        state.options.forEach(function (select) { select.disabled = false; });
        state.form.removeAttribute('aria-busy');
        render(state);
      }
      CartJS.addItem(id, quantity, {}, {
        success: function () {
          finish();
          state.status.textContent = 'Added to cart: ' + state.variant.title + ', quantity ' + quantity + '.';
          if (root.isConnected && root.closest('.shopWrapper.active')) {
            window.jQuery('.block-cart').addClass('active');
          }
        },
        error: function (response) {
          finish();
          var description = response && response.responseJSON && response.responseJSON.description;
          state.status.textContent = typeof description === 'string' ? description : 'Could not add this item. Please try again.';
        }
      });
    });
    var firstOption = state.options.find(function (select) { return select.hasAttribute('data-size-option'); }) || state.options[0];
    // The Ajax loader inserts the panel before its opening transition finishes.
    window.requestAnimationFrame(function () {
      if (firstOption && root.isConnected && wrapper && wrapper.classList.contains('active')) firstOption.focus();
    });
  }

  function scan() {
    document.querySelectorAll('[data-titsco-quickshop]').forEach(init);
  }
  window.titscoQuickShopSize = { scan: scan };
  scan();
})();
